import Loadable from 'react-loadable';

import { FooterTheme } from '@rover/kibble/styles';
import { CommerceAdminToolbar } from '@rover/react-lib/src/components/CommerceAdminToolbar/CommerceAdminToolbar';
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import retry from '@rover/rsdk/src/modules/Network/retry';
import Route from '@rover/types/src/Route';

import Loading from '../client/Loading';

const UCDevCheckoutPage = Loadable({
  loader: () => retry(() => import('@rover/react-lib/src/pages/commerce/UCDevCheckoutPage')),
  loading: Loading,
});

const ProcessingPage = Loadable({
  loader: () => retry(() => import('@rover/react-lib/src/pages/commerce/ProcessingPage')),
  loading: Loading,
});

const routes: Route[] = [
  {
    path: '/checkout/:orderCollectionOpk/',
    pageName: 'checkout',
    component: UCDevCheckoutPage,
    componentName: 'UCDevCheckoutPage',
    concept: CONCEPTS.payments.payins,
    isReactQueryRoute: true,
    exact: true,
    requiresAuth: true,
  },
  {
    path: '/checkout/:orderOpk/processing/',
    pageName: 'checkout-processing',
    component: ProcessingPage,
    componentName: 'ProcessingPage',
    concept: CONCEPTS.payments.payins,
    isReactQueryRoute: true,
    exact: true,
    requiresAuth: true,
  },
].map((route) => ({
  ...route,
  pageCategory: 'checkout',
  footerTheme: FooterTheme.LIGHT,
  cacheTag: ['page-checkout', 'page-all'],
  toolbarComponent: CommerceAdminToolbar,
}));

export default routes;
